import { useParams, Link } from 'react-router-dom';

import { Doc } from '@/api/types/backend-dto-types';
import { Label } from '@/new/components/shadcn/label';

export function DocRelationships({ doc }: { doc: Doc }) {
  const { matterId, subsetId } = useParams();
  return (
    <div className="space-y-4">
      {doc.file.parentFiles && doc.file.parentFiles.length > 0 && (
        <div className="space-y-1">
          <Label className="text-xs font-medium tracking-wide text-gray-500 uppercase">Attachment of</Label>

          <ol className="max-h-48 space-y-1 overflow-y-auto text-sm text-gray-900 [counter-reset:item]">
            {doc.file.parentFiles.map((parent) => (
              <li
                key={parent.id}
                className="flex items-center gap-1 [counter-increment:item] before:font-mono before:text-gray-400 before:content-[counter(item)'.']"
              >
                {parent.doc?.id ? (
                  <Link
                    className="w-full truncate text-left text-blue-600 hover:text-blue-700"
                    to={`/matters/${matterId}/subsets/${subsetId}/docs/${parent.doc.id}`}
                    onClick={(e) => e.stopPropagation()}
                  >
                    {parent.name}
                  </Link>
                ) : (
                  <span className="w-full truncate text-left text-gray-500">{parent.name}</span>
                )}
              </li>
            ))}
          </ol>
        </div>
      )}

      {doc.file.childFiles && doc.file.childFiles.length > 0 && (
        <div className="space-y-1">
          <Label className="text-xs font-medium tracking-wide text-gray-500 uppercase">Attachments</Label>

          <ol className="max-h-48 space-y-1 overflow-y-auto text-sm text-gray-900 [counter-reset:item]">
            {doc.file.childFiles.map((child) => (
              <li
                key={child.id}
                className="flex items-center gap-1 [counter-increment:item] before:font-mono before:text-gray-400 before:content-[counter(item)'.']"
              >
                {child.doc?.id ? (
                  <Link
                    to={`/matters/${matterId}/subsets/${subsetId}/docs/${child.doc.id}`}
                    className="w-full truncate text-left text-blue-600 hover:text-blue-700"
                    onClick={(e) => e.stopPropagation()}
                  >
                    {child.name}
                  </Link>
                ) : (
                  <span className="w-full truncate text-left text-gray-500">{child.name}</span>
                )}
              </li>
            ))}
          </ol>
        </div>
      )}
    </div>
  );
}
